import { render, staticRenderFns } from "./imgTextStatistics.vue?vue&type=template&id=6680cb4a&scoped=true&"
import script from "./imgTextStatistics.vue?vue&type=script&lang=ts&"
export * from "./imgTextStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./imgTextStatistics.vue?vue&type=style&index=0&id=6680cb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680cb4a",
  null
  
)

export default component.exports